import React from "react";

const features = [
  {
    title: "Better Customer Experience",
    text: "Visitors should be able to find products, compare options, and complete purchases with minimal effort.",
  },
  {
    title: "Mobile Performance",
    text: "Most ecommerce traffic comes from mobile devices. We make sure your store works well on every screen size.",
  },
  {
    title: "Search Engine Visibility",
    text: "<a href='/seo-services' class='blue-link'>Technical SEO</a> is considered throughout development. We build stores with clean code, structured navigation, optimized URLs, and proper metadata to support long-term organic growth.",
  },
  {
    title: "Flexible Growth",
    text: "As your product range, markets, or business model change, your Shopify Plus store should adapt without requiring a complete rebuild.",
  },
];

export default function Section13() {
  return (
    <div className="w-full Section13 py-[4%] bg-[#fff]">
      <div className="w-[92%] md:w-[85%] mx-auto section13-container">
        <div className="w-full flex flex-col md:flex-row items-center gap-y-6 md:gap-x-[5%] pb-[4%]">
          <div className="w-full md:w-[58%] text-center md:text-left">
            <h2 className="text-[24px] md:text-[34px] font-bold text-[#151515] leading-[29px] md:leading-[41px] my-[0.67em]">
              Shopify Plus Websites Built for Performance
            </h2>
            <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open mb-3">
              A visually attractive website is important, but performance
              matters just as much. Slow loading pages, confusing navigation,
              and unnecessary complexity can reduce conversions even when
              traffic is strong.
            </p>
            <p className="leading-[22px] text-[#373737] text-sm md:text-base font-open">
              Our goal is to build Shopify Plus websites that are fast, easy to
              use, and simple to manage. We focus on:
            </p>
          </div>
          <div className="w-full md:w-[38%]">
            <img
              src="/assets/Shopify Plus Websites Built for Performance.webp"
              alt="Shopify Plus Websites Built for Performance"
              className="w-full h-auto"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
          {features.map((item, index) => (
            <div
              key={item.title}
              className="bg-white rounded-[8px] p-[6%] border-t-[3px] border-[#DA2128] shadow-sm"
            >
              <span className="text-[#DA2128] text-3xl font-bold font-open">
                {String(index + 1).padStart(2, "0")}
              </span>
              <h3 className="text-[16px] md:text-[18px] font-bold leading-[24px] text-[#151515] my-[0.5em]">
                {item.title}
              </h3>
              <p
  className="text-xs md:text-sm leading-[20px] text-[#373737] font-open"
  dangerouslySetInnerHTML={{ __html: item.text }}
/>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}